// src/components/Footer.jsx

// 1. Importe os ícones necessários
import { Phone, Mail, MapPin } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    // 2. Adicione um pouco mais de padding vertical para acomodar as duas linhas
    <footer className="w-full bg-gray-100 px-4 py-6 text-center dark:bg-gray-900">
      {/* Linha de Copyright (permanece a mesma) */}
      <p className="text-sm text-gray-500 dark:text-gray-400">
        &copy; {currentYear}{' '}
        <a
          href="https://www.konsilo.com.br"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-blue-600 hover:underline dark:text-blue-500"
        >
          Konsilo Soluções
        </a>
        . Todos os direitos reservados.
      </p>

      {/* --- MUDANÇA: Nova linha de informações de contato --- */}
      <div className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
        {/* Telefone */}
        <a href="tel:+5521982837322" className="flex items-center gap-2 text-xs text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-500">
          <Phone size={14} />
          <span>+55 (21 ) 98283-7322</span>
        </a>

        {/* Email */}
        <a href="mailto:contato@konsilo.com.br" className="flex items-center gap-2 text-xs text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-500">
          <Mail size={14} />
          <span>contato@konsilo.com.br</span>
        </a>

        {/* Localização */}
        <div className="flex items-center gap-2 text-xs text-gray-600 dark:text-gray-400">
          <MapPin size={14} />
          <span>Rio de Janeiro, RJ</span>
        </div>
      </div>
    </footer>
  );
}
